import React, { useEffect } from "react";

import Footer from "../components/footer";
import Switcher from "../components/switcher";
import Team from "../components/team";
import StatsCards from "../components/StatsCards";
import "../../node_modules/react-modal-video/css/modal-video.css";
import Navbar from "../components/navbar";
import VisionMissionValues from "../components/VisionMissionValues";
import img from "../assets/images/sidom/fotos/pinSIDOM.png";
import { Helmet, HelmetProvider } from "react-helmet-async";
import HeroComex from "../components/HeroComex";
import useStore from "../store/useStore";

export default function AboutUs() {
  const { nosotrosHeroes, getNosotrosHeroes } = useStore();
  useEffect(() => {
    getNosotrosHeroes();
  }, [getNosotrosHeroes]);
  console.log();
  // const [isOpen, setOpen] = useState(false);
  return (
    <HelmetProvider>
      <Helmet>
        <title>Sobre Nosotros | SIDOM</title>
        <meta
          name="description"
          content="Conoce la historia, misión y visión de SIDOM, líder en soluciones tecnológicas para comercio exterior y logística internacional."
        />
        <meta property="og:title" content="Sobre Nosotros | SIDOM" />
        <meta
          property="og:description"
          content="Conoce la historia, misión y visión de SIDOM, líder en soluciones tecnológicas para comercio exterior y logística internacional."
        />
        <meta
          property="og:image"
          content="https://sidomsuite.com/wp-content/themes/sidom-pay/assets/about-hiro.jpg"
        />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <header>
        <Navbar />
      </header>
      <main className="bg-sidom-light dark:bg-sidom-blue text-sidom-dark dark:text-sidom-light">
        {nosotrosHeroes &&
          nosotrosHeroes.map((item, index) => (
            <HeroComex video={item.video[0]?.url} height="h-[300px]" />
          ))}
        <section className="relative md:py-24 py-16">
          <div className="container ">
            <div className="flex flex-col md:flex-row items-start gap-20  text-xl">
              <div className=" w-[50%] flex flex-col items-end justify-start">
                <img
                  src={img}
                  className="rounded-lg h-full w-[65px]   relative"
                  alt=""
                />
                <p className="mb-4 leading-7 text-balance text-left font-medium">
                  <strong className="text-sidom-orange">SIDOM </strong>surge de
                  una historia de sueños audaces, perseverancia y una visión
                  global. Fundada por tres emprendedores con una pasión
                  inquebrantable por revolucionar el comercio exterior, nuestra
                  empresa nació en un modesto galpón en Argentina, impulsada por
                  un propósito claro: ofrecer una solución integral e innovadora
                  para la gestión de la logística y el comercio internacional.
                </p>
              </div>
              <div className="  w-[50%]">
                <div className="">
                  <p className="text-sidom-dark leading-7  text-left  dark:text-sidom-light mx-auto">
                    Desde el comienzo, sabíamos que el éxito en el comercio
                    global requiere algo más que tecnología avanzada. Requiere
                    entender y abrazar las complejidades únicas de cada cliente.
                    Fue nuestra obsesión por el cliente lo que nos llevó a
                    desarrollar un enfoque personalizado, mucho antes de que
                    este concepto se convirtiera en una tendencia. Cada desafío
                    que enfrentaron nuestros clientes se convirtió en una
                    oportunidad para innovar y automatizar, creando un producto
                    que no solo se adapta, sino que se anticipa a las
                    necesidades cambiantes del mercado. <br />
                    <br />
                    Hoy, después de
                    <strong> 10 años </strong>de liderazgo y presencia en
                    <strong> 14 países,</strong>
                    <strong className="text-sidom-orange"> SIDOM</strong> no
                    sólo ha cumplido su promesa, sino que la ha elevado a nuevas
                    alturas. Nuestra suite de soluciones es única por su
                    capacidad para integrarse perfectamente con el ecosistema
                    del comercio global de todo el mundo y adaptarse a los
                    procesos específicos de cada empresa. Este enfoque flexible
                    y nuestra capacidad de personalización nos han convertido en
                    el aliado preferido para las principales empresas globales,
                    así como para marcas regionales en expansión.
                    <br />
                    <br /> El mundo del comercio internacional está en constante
                    evolución, y en 
                    <strong className="text-sidom-orange"> SIDOM</strong> ,
                    estamos comprometidos a ser el socio que guía a las empresas
                    hacia el futuro. Nuestro software no solo resuelve
                    problemas, sino que anticipa desafíos y ofrece una
                    plataforma escalable para crecer junto a nuestros clientes.
                    Somos el puente entre la ambición regional y el éxito
                    global.
                    <br />
                    <br /> Únete a nosotros <br />
                    <br /> y descubre cómo, con la misma pasión con la que
                    surgimos y nos consolidamos como la solución Saas número 1
                    en el mercado, podemos acompañarte en tu viaje hacia la
                    automatización y eficientización de tu cadena logística en
                    todo el mundo, transformando la forma en que manejas el
                    comercio global y elevando tu negocio a nuevas alturas.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Team />
        <VisionMissionValues />
        <StatsCards />
      </main>
      <footer>
        <Footer />
      </footer>
      <Switcher />
    </HelmetProvider>
  );
}
